export default __webpack_public_path__ + "static/media/4.8d1186c6.jpg";